// types
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  openItem: ['device-info'],
  openItemTitle: ['Device Info'],
  defaultId: 'device-info',
  defaultIdTitle: 'Device Info',
  openComponent: 'buttons',
  drawerOpen: false,
  selectedDevice: null,
  deviceList: [],
  appUser: {
    email: '',
    firstName: '',
    lastName: ''
  },
  componentDrawerOpen: true,
  appAlert: {
    show: false,
    alertType: 'info',
    alertMessage: ''
  }
};

const appRed = createSlice({
  name: 'app-reducer',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
      state.openItemTitle = action.payload.openItemTitle;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },

    showAppAlert(state, action) {
      state.appAlert = {
        show: action.payload.show,
        alertType: action.payload.alertType,
        alertMessage: action.payload.alertMessage
      };
    },

    setSelectedDevice(state, action) {
      state.selectedDevice = action.payload.selectedDevice;
    },

    setDeviceList(state, action) {
      state.deviceList = action.payload.deviceList;
    },

    setAppUser(state, action) {
      state.appUser = action.payload.appUser;
    }
  }
});

export default appRed.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer, showAppAlert, setSelectedDevice, setDeviceList, setAppUser } =
  appRed.actions;
